var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ loader: true, fadeout: !_vm.isLoading },attrs:{"id":"loading-wrapper"}},[_c('div',{attrs:{"id":"loading-text"}},[_vm._v("MOOVITA")]),_c('div',{attrs:{"id":"loading-content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }